export const currencySymbols = [
  '\u0024', // $
  '\u20AC', // €
  '\u00A5', // ¥
  '\u00A3', // £
  '\u00A2', // ¢
  '\u20A0', // ₠
  '\u20A1', // ₡
  '\u20A2', // ₢
  '\u20A3', // ₣
  '\u20A4', // ₤
  '\u00A4', // ¤
  '\u20BF', // ₿
  '\u20A5', // ₥
  '\u20A6', // ₦
  '\u20A7', // ₧
  '\u20A8', // ₨
  '\u20A9', // ₩
  '\u20AA', // ₪
  '\u20AB', // ₫
  '\u20AD', // ₭
  '\u20AE', // ₮
  '\u20AF', // ₯
  '\u20B1', // ₱
  '\u20B2', // ₲
  '\u20B3', // ₳
  '\u20B4', // ₴
  '\u20B5', // ₵
  '\u20B8', // ₸
  '\u20B9', // ₹
  '\u20BA', // ₺
  '\u20BC', // ₼
  '\u20BD', // ₽
];

export const textSymbols = [
  '\u2039', // ‹
  '\u203A', // ›
  '\u00AB', // «
  '\u00BB', // »
  '\u0027', // '
  '\u2018', // ‘
  '\u201C', // “
  '\u201D', // ”
  '\u201A', // ‚
  '\u201E', // „
  '\u00A1', // ¡
  '\u00BF', // ¿
  '\u2025', // ‥
  '\u2026', // …
  '\u01C2', // ǂ
  '\u2030', // ‰
  '\u2031', // ‱
  '\u203C', // ‼
  '\u2049', // ⁉
  '\u2048', // ⁈
  '\u2047', // ⁇
  '\u00A9', // ©
  '\u00AE', // ®
  '\u2122', // ™
  '\u00A7', // §
  '\u00B6', // ¶
  '\u204B', // ⁋
];

export const mathematicalSymbols = [
  '\u003C', // <
  '\u003E', // >
  '\u2264', // ≤
  '\u2265', // ≥
  '\u2012', // ‒
  '\u2014', // —
  '\u00AF', // ¯
  '\u00B1', // ±
  '\u00B0', // °
  '\u2212', // −
  '\u00B1', // ±
  '\u00F7', // ÷
  '\u2044', // ⁄
  '\u00D7', // ×
  '\u0192', // ƒ
  '\u222B', // ∫
  '\u2211', // ∑
  '\u221E', // ∞
  '\u221A', // √
  '\u007E', // ~
  '\u2248', // ≈
  '\u2260', // ≠
  '\u220F', // ∏
  '\u00AC', // ¬
  '\u2205', // ∅
  '\u002A', // *
  '\u00BC', // ¼
  '\u00BD', // ½
  '\u00BE', // ¾
];

export const arrowSymbols = [
  '\u27F5', // ⟵
  '\u27F6', // ⟶
  '\u2191', // ↑
  '\u2193', // ↓
  '\u27F8', // ⟸
  '\u27F9', // ⟹
  '\u21E4', // ⇤
  '\u21E5', // ⇥
  '\u2913', // ⤓
  '\u2195', // ↕
];

export const latinSymbols = [
  '\u0100', // Ā
  '\u0101', // ā
  '\u0102', // Ă
  '\u0103', // ă
  '\u0104', // Ą
  '\u0105', // ą
  '\u0106', // Ć
  '\u0107', // ć
  '\u0108', // Ĉ
  '\u0109', // ĉ
  '\u010A', // Ċ
  '\u010B', // ċ
  '\u010C', // Č
  '\u010D', // č
  '\u010E', // Ď
  '\u010F', // ď
  '\u0189', // Ɖ
  '\u0111', // đ
  '\u0112', // Ē
  '\u0113', // ē
  '\u0114', // Ĕ
  '\u0115', // ĕ
  '\u0116', // Ė
  '\u0117', // ė
  '\u0228', // Ȩ
  '\u0119', // ę
  '\u011A', // Ě
  '\u011B', // ě
  '\u011C', // Ĝ
  '\u011D', // ĝ
  '\u011E', // Ğ
  '\u011F', // ğ
  '\u0120', // Ġ
  '\u0121', // ġ
  '\u0124', // Ĥ
  '\u0125', // ĥ
  '\u0126', // Ħ
  '\u045B', // ћ
  '\u0128', // Ĩ
  '\u0129', // ĩ
  '\u012A', // Ī
  '\u012B', // ī
  '\u012C', // Ĭ
  '\u012D', // ĭ
  '\u0130', // İ
  '\u0131', // ı
  '\u0133', // ĳ
  '\u0134', // Ĵ
  '\u0135', // ĵ
  '\u0136', // Ķ
  '\u0137', // ķ
  '\u0139', // Ĺ
  '\u013A', // ĺ
  '\u013B', // Ļ
  '\u013C', // ļ
  '\u013D', // Ľ
  '\u013E', // ľ
  '\u0141', // Ł
  '\u0142', // ł
  '\u0143', // Ń
  '\u0144', // ń
  '\u0145', // Ņ
  '\u0146', // ņ
  '\u0147', // Ň
  '\u0148', // ň
  '\u0149', // ǹ
  '\u014A', // Ŋ
  '\u014B', // ŋ
  '\u014C', // Ō
  '\u014D', // ō
  '\u014E', // Ŏ
  '\u014F', // ŏ
  '\u0150', // Ő
  '\u0151', // ő
  '\u0152', // Œ
  '\u0153', // œ
  '\u0154', // Ŕ
  '\u0155', // ŕ
  '\u0156', // Ŗ
  '\u0157', // ŗ
  '\u0158', // Ř
  '\u0159', // ř
  '\u015A', // Ś
  '\u015B', // ś
  '\u015E', // Ş
  '\u015F', // ş
  '\u0160', // Š
  '\u0161', // š
  '\u0162', // Ţ
  '\u01AB', // ƫ
  '\u0164', // Ť
  '\u0165', // ť
  '\u0168', // Ũ
  '\u0169', // ũ
  '\u016A', // Ū
  '\u016B', // ū
  '\u016C', // Ŭ
  '\u016D', // ŭ
  '\u016E', // Ů
  '\u016F', // ů
  '\u0170', // Ű
  '\u0171', // ű
  '\u0172', // Ų
  '\u0173', // ų
  '\u0174', // Ŵ
  '\u0175', // ŵ
  '\u0176', // Ŷ
  '\u0177', // ŷ
  '\u0178', // Ÿ
  '\u0179', // Ź
  '\u017A', // ź
  '\u017B', // Ż
  '\u017C', // ż
  '\u017D', // Ž
];
